/* unplugin-vue-components disabled */import { render } from "./voice-form.vue?vue&type=template&id=2267d3da"
import script from "./voice-form.vue?vue&type=script&lang=js"
export * from "./voice-form.vue?vue&type=script&lang=js"

import "./voice-form.vue?vue&type=style&index=0&id=2267d3da&lang=less"

import exportComponent from "E:\\ProjectsWorkspaces\\WebStormProjects\\OCHS-Product-Disda-Online-Car-Hailing-H5\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_7401bc125e2957ce4091f6809056b31d\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__